import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { hasDocsComplete as hasDocsCompleteSelector } from '../../../api/lendingAPI/ProductOfferAPIHelper';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { PendingIllustrationSVG } from '../../../svgComponents/pendingIllustrationSVG/index';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';
import { StateView } from '../../pageStructure/stateView/index';
import MissingDocsView from './missingDocsView/MissingDocsView';
import PendingStatusSVG from './pendingStatusSVG/PendingStatusSVG';

import messages from './PendingView.messages';
import styles from './PendingView.module.css';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    hasDocsComplete: hasDocsCompleteSelector(state)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const PendingView = ({ hasDocsComplete }: PropsFromRedux) => {
    if (getCountry() === 'DE') {
        return (
            <StateView
                image={<PendingIllustrationSVG />}
                headerMessage={<FormattedMessage {...messages.pendingHeader} />}
                descriptionMessage={
                    <FormattedMessage {...messages.pendingDescription} />
                }
            />
        );
    }

    if (!hasDocsComplete) return <MissingDocsView />;

    return (
        <MainSectionWrapper>
            <div className={styles.pendingStatus}>
                <PendingStatusSVG className={styles.PendingViewSVG} />

                <h1 className={styles.title} data-testid="pendingView-headline">
                    Thanks your application is in progress. We’ll get back to
                    you as soon as possible.
                </h1>

                <p className={styles.subtext}>
                    We’ll aim to email you with a decision within 24 hours -
                    we’re reviewing more applications than usual at the moment,
                    so please bear with us if we take a little longer.
                </p>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(PendingView);
